import React, {PureComponent, ReactNode} from "react"
import styled, {css} from "styled-components"

import Flex from "@irati/ui/src/Flex"

const Container = styled(Flex)`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 14px;

  ${({theme}) => css`
    color: ${theme.colors.greys.white};
    background-color: ${theme.colors.perkbox.blue};
    font-family: ${theme.font.bold};

    ${theme.mediaQueries.minWidthMedia.tablet`
      width: 24px;
      height: 24px;
    `}
  `}
`

interface Props {
  children: ReactNode,
  className?: string
}

class Badge extends PureComponent<Props> {
  static defaultProps = {
    className: null
  }

  render() {
    const {className, children} = this.props
    return (
      <Container className={className} alignItems="center" justifyContent="center">
        {children}
      </Container>
    )
  }
}

export default Badge
